
import React from 'react';
import { Fan } from 'lucide-react';
import KpiDetailLayout from '@/components/kpi/KpiDetailLayout';
import { OverviewTab } from '@/components/kpi/hvac/OverviewTab';
import { PerformanceTab } from '@/components/kpi/hvac/PerformanceTab';
import { MaintenanceTab } from '@/components/kpi/hvac/MaintenanceTab';

// Main HVAC Runtime component
const HvacRuntime = () => {
  const tabs = [
    { id: 'overview', label: 'Overview', content: <OverviewTab /> },
    { id: 'performance', label: 'Performance', content: <PerformanceTab /> },
    { id: 'maintenance', label: 'Maintenance', content: <MaintenanceTab /> }
  ];
  
  return (
    <KpiDetailLayout
      id="hvac-runtime"
      title="HVAC Runtime"
      icon={<Fan className="h-5 w-5 text-emerald-600" />}
      colorClass="bg-emerald-50 dark:bg-emerald-900/20"
      tabs={tabs}
    />
  );
};

export default HvacRuntime;
